import DragDropInputFile from "./DragDropInputFile";

export default DragDropInputFile;
